module.exports = __webpack_public_path__ + "img/file_logo.82d30d91.png";